import React from "react";
import ImageGrid from "../../../components/company_grid";
import Footer from "../../../components/footer";
import BlogHeroSection from "../../About/blog/blog_page";
import BlogCart from "../../About/blog/blog_carts";

function Home() {
  return (
    <div>
      <BlogHeroSection />
      <BlogCart/>
      <ImageGrid />
      <Footer />
    </div>
  );
}

export default Home;
